module.exports = __webpack_public_path__ + "static/img/logo.e8854951.png";